import { makeAutoObservable } from 'mobx'
import { type Integration } from 'entities/Integrations'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'
import { IntegrationCustomSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCustomSettingsStore'
import { IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { IntegrationSettingsPropertyStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsPropertyStore'
import { type IZohoSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationZohoSettings/types'
import { IntegrationSyncType } from 'pages/settings/pages/integrations/pages/integrationSettings/lib'

export class IntegrationZohoSettingsStore {
  private _collapseStore
  private _customSettingsStore
  private _syncStore
  private _propertyStore

  constructor(integration: Integration, private _entities: IEntitiesStore) {
    this._collapseStore = new IntegrationCollapseSettingsStore()
    this._customSettingsStore = new IntegrationCustomSettingsStore<IZohoSettingsDict>(
      integration,
      this._entities
    )
    this._syncStore = new IntegrationSettingsSyncStore(integration, this._customSettingsStore, [])
    this._propertyStore = new IntegrationSettingsPropertyStore(
      integration,
      this._customSettingsStore,
      this._entities,
      true
    )
    makeAutoObservable(this)
  }

  init = () => {
    this._customSettingsStore.init1_0()
    this._propertyStore.init()
    this._syncStore.setSyncType(IntegrationSyncType.twoWay)
  }

  get collapseStore() {
    return this._collapseStore
  }

  get propertyStore() {
    return this._propertyStore
  }

  get syncStore() {
    return this._syncStore
  }
}
